import {NavigationExtras} from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { DBService } from 'src/app/services/db.service';
import { BonuskarteService } from 'src/app/services/bonuskarte.service';
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';;
import { Bonuskarte } from 'src/app/models/bonuskarte.model';
import { UserService } from 'src/app/services/user.service';

import { UtilService } from 'src/app/services/util.service';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-bonuskarte-customer',
  templateUrl: './bonuskarte-customer.page.html',
  styleUrls: ['./bonuskarte-customer.page.scss'],
})
export class BonuskarteCustomerPage implements OnInit {

  constructor(public db: DBService, public bonuskartenService: BonuskarteService, private ngZone: NgZone, private router: Router, public userService:UserService,
    private util:UtilService, private alert:AlertService) { }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }

    this.db.currentPage = 'home'
  }

  einloesen(bonuskarte: Bonuskarte){
    localStorage.setItem('openID', JSON.stringify(bonuskarte.idAsBonus))
    this.util.enableBonuskarten = true

    setTimeout(() => {
      this.ngZone.run(() => {
        this.router.navigate(['/menu'])
      })
    }, 150);
  }

  getPseudoArray(bonuskarte: Bonuskarte): number[] {
    let currentAmount = this.getCurrentItemsForBonuskarte(bonuskarte)
    let currentUnsureAmount = this.getCurrentItemsForBonuskarte(bonuskarte, false)
    currentUnsureAmount = currentUnsureAmount - currentAmount

    let pseudoArray: number[] = [];
    for (let i = 0; i < bonuskarte.requiredAmount; i++) {
      if (currentAmount > i) {
        pseudoArray.push(1)
      } else if (currentUnsureAmount > 0) {
        currentUnsureAmount--
        pseudoArray.push(0)
      } else {
        pseudoArray.push(-1)
      }

    }

    return pseudoArray;
  }

  async toggleBonuscard(id:string){
    if(this.userService.getBonuscard(id) === -1){
      this.userService.setBonuscard(id, (new Date().getTime() - 43200000)) //-12h, damit die letzten Drinks noch zaehlen
    }else{
      this.alert.presentAlertConfirm(this, (ref) => {ref.userService.setBonuscard(id, -1)}, 'Nicht mehr an dieser Bonuskarte teilnehmen?', 'Du verliertst alle gesammelten Punkte')
    }
  }

  back() {
    this.ngZone.run(() => this.router.navigate(['/customer-home']))
  }

  currentItemsOfBonuskarte = {}
  currentTsOfBonuskarte = {}
  //da diese Methode ganz oft aufgerufen wird, ist ein cache eingebaut, der nur alle 15s aktualisiert wird.
  getCurrentItemsForBonuskarte(bonuskarte, onlySafeOrders: boolean = true){
    if(this.currentTsOfBonuskarte[bonuskarte.id] > new Date().getTime()-15000){
      return this.currentItemsOfBonuskarte[bonuskarte.id]
    }
    this.currentItemsOfBonuskarte[bonuskarte.id] = this.bonuskartenService.getCurrentItemsForBonuskarte(bonuskarte, onlySafeOrders)
    this.currentTsOfBonuskarte[bonuskarte.id] = new Date().getTime()
    return this.currentItemsOfBonuskarte[bonuskarte.id]
  }


}
